import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {MiniCartController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import GooglePayGateway from "../gateways/GooglePayGateway";

const settings = getSetting('ppcp_googlepay_data');

const gateway = new GooglePayGateway({
    id: 'ppcp_googlepay',
    cart,
    settings: settings,
    controller: null // Will be set after controller creation
});

// Create cart controller with gateway
const controller = new MiniCartController({
    id: 'ppcp_googlepay',
    cart,
    context: new Context('minicart'),
    gateway,
    settings
});

controller.initialize();